import {
  AddBusinessOutlined,
  BusinessOutlined,
  CategoryOutlined,
  ChatOutlined,
  ClearAllOutlined,
  DarkMode,
  FolderOutlined,
  HomeOutlined,
  LightMode,
  PowerSettingsNewOutlined,
  QrCode2Outlined,
  SettingsOutlined,
  SwapHoriz,
  ViewCarouselOutlined,
} from '@mui/icons-material';
import { Badge, Chip } from '@mui/material';
import {
  ChangeThemeSwitch,
  MenuListProps,
  ThemeMode,
} from '@sahinyazilim/sahinyazilim-components';
import { AccountRouteNames } from 'account/common/model/AccountRouteNames';
import { Payment } from 'account/payment/model/payment';
import { CommonRouteNames } from 'common/contact/common/model/CommonRouteNames';
import { commonActions } from 'common/context/CommonSlice';
import { store } from 'common/context/store';
import { createLink as createLinkHelper } from 'common/helper/createRoute';
import { ProjectRouteNames } from 'common/helper/ProjectRouteNames';
import { AdminRouteNames } from 'common/model/AdminRouteNames';
import { NullUndefined } from 'common/model/NullUndefined';
import { orderActions } from 'context/OrderSlice';
import { NavigateFunction } from 'react-router-dom';

type CustomMenuListProps = MenuListProps & {
  navigate: NavigateFunction;
  currentPlan: NullUndefined<Payment>;
  newOrderCount?: number;
  branchId: string | null | undefined;
};

export const menuList = ({
  open,
  theme,
  selectTheme,
  navigate,
  currentPlan,
  newOrderCount = 0,
  branchId,
}: CustomMenuListProps) => {
  return [
    {
      id: 1,
      menu: [
        {
          label: 'Raporlar',
          icon: HomeOutlined,
          action: () => () =>
            navigate(
              createLinkHelper(AdminRouteNames, AdminRouteNames.HOME, branchId),
            ),
        },
        {
          label: 'Siparişler',
          icon: AddBusinessOutlined,
          action: () => () =>
            navigate(
              createLinkHelper(
                AdminRouteNames,
                AdminRouteNames.ORDER,
                branchId,
              ),
            ),
          badge:
            newOrderCount > 0 ? (
              <Badge
                badgeContent={newOrderCount}
                color="error"
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
              />
            ) : undefined,
        },
        {
          label: 'Ürünler',
          icon: CategoryOutlined,
          action: () => () =>
            navigate(
              createLinkHelper(
                AdminRouteNames,
                AdminRouteNames.PRODUCT,
                branchId,
              ),
            ),
        },
        {
          label: 'Kategoriler',
          icon: ClearAllOutlined,
          action: () => () =>
            navigate(
              createLinkHelper(
                AdminRouteNames,
                AdminRouteNames.CATEGORY,
                branchId,
              ),
            ),
        },
        {
          label: 'Anasayfa Slider',
          icon: ViewCarouselOutlined,
          action: () => () =>
            navigate(
              createLinkHelper(
                AdminRouteNames,
                AdminRouteNames.SLIDER,
                branchId,
              ),
            ),
        },
        {
          label: 'Dosyalar',
          icon: FolderOutlined,
          action: () => () =>
            navigate(
              createLinkHelper(
                AdminRouteNames,
                AdminRouteNames.FILES,
                branchId,
              ),
            ),
        },
      ],
    },
    {
      id: 3,
      menu: [
        {
          label: 'QR Editör',
          icon: QrCode2Outlined,
          action: () => () =>
            navigate(
              createLinkHelper(
                AdminRouteNames,
                AdminRouteNames.CORPORATEL_IDENTITY,
                branchId,
              ),
            ),
        },
        {
          label: 'İletişim Talepleri',
          icon: ChatOutlined,
          action: () => () =>
            navigate(
              createLinkHelper(
                AdminRouteNames,
                CommonRouteNames.CONTACT,
                branchId,
              ),
            ),
        },
        {
          label: 'Hesap Yönetimi',
          icon: BusinessOutlined,
          badge: (
            <Chip
              label={currentPlan?.plan?.title || 'FREE'}
              color={!currentPlan?.plan?.title ? 'primary' : 'warning'}
              variant="outlined"
              size="small"
            />
          ),
          action: () => () =>
            navigate(
              createLinkHelper(
                AdminRouteNames,
                `${AdminRouteNames.ACCOUNT}/${AccountRouteNames.PLAN}`,
                branchId,
              ),
            ),
        },
        {
          label: 'Ayarlar',
          icon: SettingsOutlined,
          action: () => () =>
            navigate(
              createLinkHelper(
                AdminRouteNames,
                AdminRouteNames.SETTING,
                branchId,
              ),
            ),
        },
        {
          label: 'Dark Mode',
          action: () => () =>
            !open &&
            selectTheme?.(
              ThemeMode.LIGHT === theme ? ThemeMode.DARK : ThemeMode.LIGHT,
            ),
          icon: ThemeMode.LIGHT === theme ? DarkMode : LightMode,
          badge: <ChangeThemeSwitch />,
        },
        {
          label: 'Şube Değiştir',
          icon: SwapHoriz,
          action: () => () =>
            navigate(
              createLinkHelper(ProjectRouteNames, ProjectRouteNames.ADMIN),
            ),
          badge: <Badge showZero color="success" variant="dot" />,
        },
        {
          label: 'Çıkış Yap',
          action: () => () => {
            store.dispatch(commonActions.setAuth(null));
            store.dispatch(orderActions.resetOrderState());
          },
          icon: PowerSettingsNewOutlined,
        },
      ],
    },
  ];
};
